import { render, staticRenderFns } from "./SecureAccessTable.vue?vue&type=template&id=e432bf52&scoped=true&"
import script from "./SecureAccessTable.vue?vue&type=script&lang=js&"
export * from "./SecureAccessTable.vue?vue&type=script&lang=js&"
import style0 from "./SecureAccessTable.vue?vue&type=style&index=0&id=e432bf52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e432bf52",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e432bf52')) {
      api.createRecord('e432bf52', component.options)
    } else {
      api.reload('e432bf52', component.options)
    }
    module.hot.accept("./SecureAccessTable.vue?vue&type=template&id=e432bf52&scoped=true&", function () {
      api.rerender('e432bf52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/SecureAccessTable.vue"
export default component.exports